import { PageInfo } from '../types';

import { Page as A1 } from './core/01-basics';
import { Page as A2 } from './core/02-zeros';
import { Page as A3 } from './core/03-nulls';
import { Page as A4 } from './core/04-counts';
import { Page as A5 } from './core/05-locked';
import { Page as A6 } from './core/06-blocked';
import { Page as A7 } from './core/07-rectangle';
import { Page as B1 } from './outer-core/01-solids';
import { Page as B2 } from './outer-core/02-empties';

export const StageList: PageInfo[] = [
  A1,
  A2,
  A3,
  A4,
  A5,
  A6,
  A7,
  B1,
  B2,
];
